import { createFileRoute } from "@tanstack/react-router";
import BranchesConfigurations from "@/components/branches/branches-configuration";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute("/_authenticated/settings/_layout/branches")({
  component: BranchesPage,
});

function BranchesPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "branches", actions: ["read", "update"] }]}
    >
      <div>
        <div className="overflow-x-auto">
          <BranchesConfigurations module="branches" />
        </div>
      </div>
    </RouteGuardPermissions>
  );
}
